module.exports = __webpack_public_path__ + "static/media/at.e2634e96.svg";